import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import {
  ImageButtonPlatformProps,
  ImageButtonDefinition,
  ImageButtonCarmiProps,
} from '../ImageButton.types';

export const props = withCompInfo<
  ImageButtonPlatformProps,
  ImageButtonDefinition,
  ImageButtonCarmiProps
>()(['compProps'], (_, carmiData) => {
  return {
    ...carmiData,
  };
});

export default createComponentMapperModel({
  props: props as any,
});
